import {Component} from '@angular/core';
import {EsignStatus} from '@npck/auth-frontend-api';
import {OauthRedirectErrorCode} from '@npck/errors-api';
import {RouterService, rxSpinner, SentryService} from '@npck/libs/commons';
import {OauthServiceApiService} from '@npck/oauth-service-api';
import {AuthHolderService} from '../../domain/auth-holder.service';
import {OauthService} from '../../domain/oauth.service';
import {Path} from '../../path';

@Component({
    template: `
        <div class="w-100 h-100" fxLayoutAlign="center center">
            <ui-kit-spinner spinnerIds="initial"></ui-kit-spinner>
        </div>
    `,
    standalone: false,
})
export class OauthAuthorizeComponent {

    constructor(
        routerService: RouterService,
        oauthHolderService: AuthHolderService,
        oauthServiceApiService: OauthServiceApiService,
        oauthService: OauthService,
        sentryService: SentryService,
    ) {
        const oauthData = oauthHolderService.authSessionData;
        const scope = oauthData.scopes.map(item => item.toLowerCase()).join(' ');

        oauthServiceApiService.authorize({
            client_id: oauthData.clientId,
            redirect_uri: oauthData.redirectUri,
            response_type: 'code',
            state: oauthData.state,
            scope,
        })
            .pipe(rxSpinner('initial'))
            .subscribe({
                next: response => {
                    oauthHolderService.storeOauthConsentData(response);
                    if (oauthData.revokeEsign) {
                        routerService.navigate(Path.ESIGN_REVOCATION);
                    } else if (oauthData.resetEsign) {
                        routerService.navigate(Path.ESIGN_RESETTING);
                    } else if (response.data?.esign?.status === EsignStatus.BLOCKED_TEMPORARILY) {
                        oauthService.handleOauthErrorAndRedirect(OauthRedirectErrorCode.esign_is_blocked);
                    } else {
                        routerService.navigate(Path.OAUTH_CONSENT);
                    }
                },
                error: error => {
                    sentryService.addBreadcrumb({
                        category: 'oauth-authorize',
                        message: 'authorize request failed in subscribe.error',
                        level: 'error',
                        data: {
                            location: 'OauthAuthorizeComponent.subscribe',
                            clientId: oauthData.clientId,
                            redirectUri: oauthData.redirectUri,
                            errorType: error?.constructor?.name,
                            httpStatus: error?.status,
                        },
                    });
                    throw error;
                },
            });
    }
}
